import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import {
  fetchAepsBalance,
  fetchWalletBalance
} from "../../../Store/Slices/WalletSlice";
import DynamicTable from "../../../ResuableCompoment/DynamicTable";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
import * as XLSX from "xlsx";

const AepsReport = () => {
  const dispatch = useDispatch();
  const { lat, lng } = useSelector((s) => s.location);
  const latitude = lat;
  const longitude = lng;
  const { username, merchant_account_no, userId } =
    useSelector((s) => s.auth.employeeDetails) || {};

  const mobile_number = useSelector(
    (s) => s.auth.employeeDetails?.mobile_number
  );

  const mid = useSelector(
    (s) => s.auth.employeeDetails?.username
  );

  useEffect(() => {
    if (mobile_number) {
      checkCustomerStatus();
    }
  }, [mobile_number]);

  const [activeTab, setActiveTab] = useState("COMMISSION");

  /* ================= COMMISSION BALANCE ================= */
  const [commissionBalance, setCommissionBalance] = useState(0);

  const { callApi: commissionApi } = useApi(
    `/business/wallet/view/aeps_wallet/balance?mid=${username}&account_no=${merchant_account_no}`,
    "GET"
  );

  const { callApi: transferCommissionToMain } = useApi(
    "/business/wallet/aeps/settle",
    "POST"
  );

  const { callApi: calculateFee } = useApi(
    "/dmt/fee/calculate/aeps/settle",
    "POST"
  );

  const { callApi: settleToBank } = useApi(
    "/settle",
    "POST"
  );

  const { callApi: settleUpi } = useApi(
    "/upi/settle",
    "POST"
  );

  const { callApi: checkStatus } = useApi("/payout/status", "GET");
  const { callApi: sendRemitterOtp } = useApi("/payout/send-otp", "POST");
  const { callApi: verifyRemitterOtp } = useApi("/payout/verify-otp", "POST");

  const { callApi: fetchUpiList } = useApi("/payout/bene/list", "GET");
  const { callApi: verifyUpiApi } = useApi("/payout/verify", "POST");
  const { callApi: addUpiApi } = useApi("/payout/bene/verify", "POST");

  const [transferCommissionAmount, setTransferCommissionAmount] = useState("");
  const [isLoadingCommission, setIsLoadingCommission] = useState(false);
  const [commissionMessage, setCommissionMessage] = useState("");

  const [showAddBankForm, setShowAddBankForm] = useState(false);
  const [addBankLoading, setAddBankLoading] = useState(false);
  const [addBankMessage, setAddBankMessage] = useState("");

  const [selectedBank, setSelectedBank] = useState(null);
  const [settleAmount, setSettleAmount] = useState("");
  const [upiSettleAmount, setUpiSettleAmount] = useState("");
  const [fee, setFee] = useState(0);
  const [txnAmount, setTxnAmount] = useState(0);
  const [loadingFee, setLoadingFee] = useState(false);

  const [mpin, setMpin] = useState("");
  const mpinRefs = React.useRef([]);

  const [settleLoading, setSettleLoading] = useState(false);
  const [settleMessage, setSettleMessage] = useState("");

  const [bankList, setBankList] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);

  const [showChequePopup, setShowChequePopup] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const [holderNameConfirm, setHolderNameConfirm] = useState("");
  const [pendingFile, setPendingFile] = useState(null);
  const [nameMismatchChoice, setNameMismatchChoice] = useState("");

  const [upiList, setUpiList] = useState([]);
  const [upiLoading, setUpiLoading] = useState(false);
  const [showUpiPopup, setShowUpiPopup] = useState(false);
  const [showVerifyConfirm, setShowVerifyConfirm] = useState(false);
  const [upiType, setUpiType] = useState("BANK");
  const [vpa, setVpa] = useState("");
  const [beneName, setBeneName] = useState("");
  const [manualBeneName, setManualBeneName] = useState("");
  const [addMode, setAddMode] = useState("VERIFY");
  const [confirmType, setConfirmType] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [upiMsg, setUpiMsg] = useState("");
  const [showMpinPopup, setShowMpinPopup] = useState(false);
  // const [remitterMobile, setRemitterMobile] = useState("");
  const [remitterName, setRemitterName] = useState("");
  const [remitterAddress, setRemitterAddress] = useState("");
  const [remitterOtp, setRemitterOtp] = useState("");
  const [remitterMessage, setRemitterMessage] = useState("");
  const [remitterMessageType, setRemitterMessageType] = useState("");
  const [remitterLoading, setRemitterLoading] = useState(false);
  const [remitterStep, setRemitterStep] = useState("CHECK");
  const [remitterMobileLocked, setRemitterMobileLocked] = useState(false);
  const [remitterMsg, setRemitterMsg] = useState("");
  const [msg, setMsg] = useState("");
  const [selectedUpi, setSelectedUpi] = useState(null);

  const [showSettlePopup, setShowSettlePopup] = useState(false);
  const [settlePopupMsg, setSettlePopupMsg] = useState("");
  const [settleStatus, setSettleStatus] = useState("");

  const UPI_SUFFIX_MAP = {
    PHONEPE: ["ybl", "ibl", "axl"],
    GOOGLEPAY: ["okicici", "okaxis", "okhdfc", "oksbi"],
    PAYTM: ["pthdfc", "ptyes", "ptaxis", "ptsbi"],
    AMAZON: ["apl"],
  };

  /* ================= AEPS LEDGER ================= */

  const getToday = () => new Date().toISOString().split("T")[0];

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());

  const MIN_SETTLE_AMOUNT = 1000;
  const MAX_SETTLE_AMOUNT = 100000;

  const [bankForm, setBankForm] = useState({
    bankName: "",
    bankNickName: "",
    accountNumber: "",
    ifscCode: "",
    accountHolderName: "",
    cancelledCheque: null,
  });

  useEffect(() => {
    if (!upiMsg) return;

    const timer = setTimeout(() => {
      setUpiMsg("");
    }, 5000); // 5 seconds

    return () => clearTimeout(timer); // cleanup
  }, [upiMsg]);

  const isBankFormValid =
    bankForm.bankName?.trim() &&
    bankForm.bankNickName?.trim() &&
    bankForm.accountNumber?.trim() &&
    bankForm.ifscCode?.trim() &&
    bankForm.accountHolderName?.trim() &&
    bankForm.cancelledCheque;

  const checkCustomerStatus = async () => {
    setRemitterLoading(true);
    setRemitterMsg("");

    try {
      const res = await checkStatus(null, `?mobile=${mobile_number}`);

      if (res?.isVerified) {
        // ✅ Already registered
        setRemitterStep("DONE");
        getUpiList();   // fetch UPI directly
      } else {
        // ❗ Not registered → show registration
        setRemitterStep("REGISTER");
      }
    } catch (err) {
      console.error("STATUS ERROR", err);
      setRemitterMsg("Failed to check customer");
    } finally {
      setRemitterLoading(false);
    }
  };

  const handleUpiSettleWithMpin = async (enteredMpin) => {
    try {
      if (!selectedUpi) {
        setUpiMsg("Please select a UPI ID");
        return;
      }

      if (!settleAmount || Number(settleAmount) <= 0) {
        setUpiMsg("Enter valid amount");
        return;
      }

      // if (!mpin || mpin.length !== 4) {
      //   setUpiMsg("Enter valid MPIN");
      //   return;
      // }

      setSettleLoading(true);
      setUpiMsg("");

      const payload = {
        mid,
        beneficiary_name: selectedUpi.name || "NA",
        beneficiary_account_number: "",
        beneficiary_ifsc_code: "",
        beneficiary_bank_name: selectedUpi.bankName || "NA",
        beneficiary_mobile: selectedUpi.mobile || mobile_number,
        beneficiary_email: "test@test.com",

        txnAmount: Number(settleAmount),
        netAmount: Number(settleAmount),

        customer_mobile: mobile_number,

        merchant_txn_id: "TXN" + Date.now(),

        paymentMode: "UPI",

        lat: latitude?.toString(),
        lng: longitude?.toString(),

        mpin: enteredMpin, // handles your mpin refs
        upi_id: selectedUpi.vpa,
      };

      console.log("SETTLE PAYLOAD →", payload);

      const res = await settleUpi(payload);

      console.log("SETTLE RESPONSE →", res);

      const message =
        res?.message ||
        res?.statusDesc ||
        res?.error ||
        res?.status ||
        "Something went wrong";

      setSettlePopupMsg(message);
      setShowSettlePopup(true);

      setUpiMsg(message);

      // if (res?.status === "SUCCESS") {
      //   setUpiMsg(res.message || "Transaction Successful");

      //   // optional reset
      //   setSelectedUpi(null);
      //   dispatch(fetchAepsBalance());
      //   setMpin("");

      // } 
      if (res?.status === "SUCCESS") {
        setSettleStatus("success");

        setSelectedUpi(null);
        setSettleAmount("");
        setMpin("");
        dispatch(fetchAepsBalance());
      } else {
        setSettleStatus("failed");
        dispatch(fetchAepsBalance());
      }
      // else {
      //   setUpiMsg(res?.message || "Transaction Failed");
      //   dispatch(fetchAepsBalance());
      // }
    }
    catch (err) {
      // console.error(err);

      // const message =
      //   err?.response?.data?.message ||
      //   err?.message ||
      //   "Network error";

      // setUpiMsg(message);
      console.error(err);

      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Network error";

      setSettlePopupMsg(message);
      setSettleStatus("failed");
      setShowSettlePopup(true);
    }
    finally {
      setSettleLoading(false);
      setSettleAmount("");
      dispatch(fetchAepsBalance());
    }
  };

  const verifyAndAddUpi = async () => {
    if (verifying) return;

    setVerifying(true);
    setUpiMsg("");

    try {
      /* ================= VERIFY ================= */
      const verifyRes = await verifyUpiApi({
        upiId: vpa,
        mid,
      });

      if (verifyRes?.status !== "SUCCESS" || !verifyRes?.accountExists) {
        // setUpiMsg(verifyRes?.message || "UPI verification failed");
        // setShowVerifyConfirm(false);
        setUpiMsg(verifyRes?.message || "Invalid UPI ID");
        return;
      }

      const verifiedName = verifyRes?.nameAtBank || "";
      setBeneName(verifiedName);

      /* ================= ADD (MANDATORY) ================= */
      const addRes = await addUpiApi({
        customerMobile: mobile_number,   // ✅ Redux mobile
        upiId: vpa,
        beneName: verifiedName,
        isVerified: true,
      });

      if (
        addRes?.verified === true ||
        addRes?.status === "SUCCESS" ||
        addRes?.status === 202   // ✅ IMPORTANT FIX
      ) {
        setUpiMsg(addRes?.message || "UPI added successfully");

        // setShowVerifyConfirm(false);
        setShowUpiPopup(false);

        // 🔥 THIS WAS MISSING IN YOUR FLOW
        getUpiList();

      } else {
        setUpiMsg(addRes?.message || "Failed to add UPI");
      }

    } catch (err) {
      console.error("VERIFY & ADD ERROR:", err);
      setUpiMsg("Something went wrong");
    } finally {
      setVerifying(false);
      dispatch(fetchWalletBalance());
    }
  };

  const handleBankInputChange = (e) => {
    const { name, value, files } = e.target;

    // if (name === "cancelledCheque") {
    //   setBankForm((prev) => ({
    //     ...prev,
    //     cancelledCheque: files[0],
    //   }));
    // } 
    if (name === "cancelledCheque") {
      const file = files[0];

      if (!file) return;

      setPendingFile(file);
      setShowChequePopup(true);
    }
    else {
      setBankForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCheckRemitter = async () => {
    if (!/^[6-9]\d{9}$/.test(mobile_number)) {
      setRemitterMessage("Enter valid 10 digit mobile");
      setRemitterMessageType("error");
      return;
    }
    setRemitterLoading(true);
    setRemitterMessage("");
    try {
      const res = await checkCustomerStatus(null, `?mobile=${mobile_number}`);
      if (res?.isVerified) {
        setRemitterStep("DONE");
        setRemitterName(res?.name || "");
        getUpiList();
      } else {
        setRemitterStep("REGISTER");
        setRemitterMobileLocked(true);
      }
    } catch {
      setRemitterMessage("Server error");
      setRemitterMessageType("error");
    }
    setRemitterLoading(false);
  };

  const handleSendRemitterOtp = async () => {
    if (!remitterName || !remitterAddress) {
      setRemitterMessage("Enter name and address");
      setRemitterMessageType("error");
      return;
    }
    setRemitterLoading(true);
    setRemitterMessage("");
    try {
      const res = await sendRemitterOtp({ mobile: mobile_number });
      if (res?.status === "OTP_SENT") {
        setRemitterStep("OTP");
        setRemitterMessage(res.message || "OTP sent successfully");
        setRemitterMessageType("success");
      } else {
        setRemitterMessage("OTP send failed");
        setRemitterMessageType("error");
      }
    } catch {
      setRemitterMessage("OTP send failed");
      setRemitterMessageType("error");
    }
    setRemitterLoading(false);
  };

  const handleVerifyRemitterOtp = async () => {
    if (remitterOtp.length !== 6) {
      setRemitterMessage("Enter valid 6 digit OTP");
      setRemitterMessageType("error");
      return;
    }
    setRemitterLoading(true);
    setRemitterMessage("");
    try {
      const res = await verifyRemitterOtp({
        mobile: mobile_number,
        otp: remitterOtp,
        name: remitterName,
        address: remitterAddress,
      });
      if (res?.status === "VERIFIED" && res?.isVerified) {
        setRemitterMessage("Customer verified successfully");
        setRemitterMessageType("success");
        setTimeout(() => {
          setRemitterStep("DONE");
          getUpiList(); // ← add this inside the timeout so it fires after DONE is set
        }, 1000);
      } else {
        setRemitterMessage("Invalid OTP");
        setRemitterMessageType("error");
      }
    } catch {
      setRemitterMessage("OTP verify failed");
      setRemitterMessageType("error");
    }
    setRemitterLoading(false);
  };

  const getUpiList = async () => {
    if (!mobile_number) return;

    setUpiLoading(true);

    try {
      const res = await fetchUpiList(
        null,
        `?mobile=${mobile_number}`   // ✅ FIXED
      );

      const list = Array.isArray(res) ? res : res?.data || [];
      setUpiList(list);
    } catch (err) {
      console.error(err);
      setUpiList([]);
    } finally {
      setUpiLoading(false);
    }
  };

  const verifyUpiOnly = async () => {
    setVerifying(true);
    setMsg("");

    try {
      const verifyRes = await verifyUpiApi({
        upiId: vpa,
        mid,
      });

      if (verifyRes?.status !== "SUCCESS" || !verifyRes?.accountExists) {
        setUpiMsg(verifyRes?.message || "UPI verification failed");
        return;
      }

      // ✅ ONLY SET NAME (NO ADD API)
      const verifiedName = verifyRes?.nameAtBank || "";
      setBeneName(verifiedName);

      setUpiMsg("UPI verified successfully");

      setShowVerifyConfirm(false);

    } catch (err) {
      console.error(err);
      setMsg("Verification failed");
    } finally {
      setVerifying(false);
    }
  };

  const addUpiDirectly = async () => {
    if (!vpa) { setUpiMsg("Enter UPI ID"); return; }
    if (!manualBeneName) { setUpiMsg("Enter beneficiary name"); return; }
    setVerifying(true);
    setUpiMsg("");
    try {
      const res = await addUpiApi({
        customerMobile: username,
        upiId: vpa,
        beneName: manualBeneName,
        isVerified: false,
      });
      if (res?.status === "SUCCESS") {
        setUpiMsg(res?.message);
        setShowVerifyConfirm(false);
        setShowUpiPopup(false);
        getUpiList();
      } else {
        setUpiMsg(res?.message || "Failed to add UPI");
      }
    } catch {
      setUpiMsg("Something went wrong");
    } finally {
      setVerifying(false);
    }
  };

  useEffect(() => {
    if (activeTab === "COMMISSION" && username) fetchLedger(0, false);
    if (activeTab === "BANK" && username) handleFetchBanks();
  }, [activeTab]);

  const handleConfirmDocument = () => {

    if (!documentType) {
      alert("Please select document type.");
      return;
    }

    if (!holderNameConfirm) {
      alert("Please confirm name match.");
      return;
    }

    if (holderNameConfirm === "NO") {

      if (!nameMismatchChoice) {
        alert("Please choose how you want to proceed.");
        return;
      }

      if (nameMismatchChoice === "UPDATE_NAME") {
        alert(
          "Please update your name with BingoPay to match your bank account name before adding this bank."
        );
        setShowChequePopup(false);
        setPendingFile(null);
        return;
      }
    }

    setBankForm((prev) => ({
      ...prev,
      cancelledCheque: pendingFile,
    }));

    setShowChequePopup(false);
    setPendingFile(null);
  };

  const handleAddBank = async () => {
    if (
      !bankForm.bankName ||
      !bankForm.accountNumber ||
      !bankForm.ifscCode ||
      !bankForm.accountHolderName ||
      !bankForm.cancelledCheque
    ) {
      setAddBankMessage("All fields are required.");
      return;
    }

    setAddBankLoading(true);
    setAddBankMessage("");

    try {
      const formData = new FormData();
      formData.append("mid", username);
      formData.append("bankName", bankForm.bankName);
      formData.append("bankNickName", bankForm.bankNickName);
      formData.append("accountNumber", bankForm.accountNumber);
      formData.append("ifscCode", bankForm.ifscCode);
      formData.append("accountHolderName", bankForm.accountHolderName);
      formData.append("cancelledCheque", bankForm.cancelledCheque);

      const res = await addBankApi(formData);

      console.log("ADD BANK RESPONSE →", res);

      // 🔥 SHOW WHATEVER API RETURNS
      // setAddBankMessage(res?.message || "Something went wrong");
      setAddBankMessage(String(res?.message || "Something went wrong"));

      if (res?.status === "SUCCESS") {
        setShowAddBankForm(false);

        // Reset form
        setBankForm({
          bankName: "",
          bankNickName: "",
          accountNumber: "",
          ifscCode: "",
          accountHolderName: "",
          cancelledCheque: null,
        });

        setSelectedBank(null);

        // Refresh list
        await handleFetchBanks();
      }

    } catch (err) {
      console.error("Add Bank Error:", err);

      // setAddBankMessage(
      //   err?.response?.data?.message ||
      //   err?.message ||
      //   "Something went wrong"
      // );
      setAddBankMessage(
        String(
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong"
        )
      );
    } finally {
      setAddBankLoading(false);
    }
  };


  const pageSize = 25;

  const { callApi: ledgerreport } = useApi(
    "/ledger/retailer",
    "GET"
  );

  const { callApi: fetchBanks } = useApi(
    "/banks",
    "GET"
  );

  const { callApi: addBankApi } = useApi(
    "/bank/add",
    "POST"
  );

  const handleFetchBanks = async () => {
    if (!username) return;

    setBankLoading(true);

    try {
      const res = await fetchBanks(null, `?mid=${username}`);
      console.log("Bank API Response:", res);

      // ✅ Case 1: Proper array response
      if (Array.isArray(res)) {
        setBankList(res);
        return;
      }

      if (Array.isArray(res?.data)) {
        setBankList(res.data);
        return;
      }

      // ✅ Case 2: 202 Accepted → No banks
      if (res?.status === 202 || res?.error_code === 202) {
        setBankList([]);
        return;
      }

      // ✅ Fallback safety
      setBankList([]);
    } catch (err) {
      console.error("Error fetching banks:", err);
      setBankList([]);
    } finally {
      setBankLoading(false);
    }
  };


  const handleCloseSettlement = () => {
    setSelectedBank(null);
    setSettleAmount("");
    setMpin("");
    setFee(0);
    setTxnAmount(0);
    setSettleMessage("");
  };


  useEffect(() => {
    (async () => {
      const res = await commissionApi();
      setCommissionBalance(res?.balance || 0);
    })();
  }, []);

  // useEffect(() => {
  //   if (activeTab === "BANK") {
  //     setSelectedBank(null);
  //     setSettleAmount("");
  //     setMpin("");
  //     setFee(0);
  //     setTxnAmount(0);
  //     setSettleMessage("");
  //   } else {
  //     setSelectedBank(null);
  //     setShowAddBankForm(false);
  //   }
  // }, [activeTab]);

  useEffect(() => {
    if (activeTab === "BANK") {
      setSelectedBank(null);
      setSettleAmount("");   // ← already present
      setMpin("");
      setFee(0);
      setTxnAmount(0);
      setSettleMessage("");
    } else if (activeTab === "UPI") {
      setSelectedUpi(null);
      setSettleAmount("");   // ← add this reset for UPI tab
      setFee(0);
      setTxnAmount(0);
    } else {
      setSelectedBank(null);
      setShowAddBankForm(false);
    }
  }, [activeTab]);

  useEffect(() => {
    const amountNumber = Number(settleAmount);

    if (!settleAmount || amountNumber <= 0) {
      setFee(0);
      setTxnAmount(0);
      setLoadingFee(false);
      return;
    }

    // BANK tab: also enforce min/max guard
    if (activeTab === "BANK" && (amountNumber < MIN_SETTLE_AMOUNT || amountNumber > MAX_SETTLE_AMOUNT)) {
      setFee(0);
      setTxnAmount(0);
      setLoadingFee(false);
      return;
    }

    const fetchFee = async () => {
      setLoadingFee(true);

      try {
        let res;

        if (activeTab === "BANK") {
          res = await calculateFee({
            paymentMode: "IMPS",
            provider: "SETTLEMENT",
            sub_provider: "EZYPAY",
            amount: amountNumber,
            commercial_type: "TRANSACTION_FEE",
            mid: username,
          });

          const calculatedFee = Number(res?.fee || 0);
          const calculatedTxnAmount = Number(res?.txn_amount) || amountNumber + calculatedFee;
          setFee(calculatedFee);
          setTxnAmount(calculatedTxnAmount);

        } else if (activeTab === "UPI") {
          res = await calculateFee({
            paymentMode: "UPI",
            provider: "SETTLEMENT",
            sub_provider: "NIFI",
            amount: amountNumber,
            commercial_type: "TRANSACTION_FEE",
            mid: mid,
          });

          const charge = res?.data?.fee ?? res?.fee ?? res?.charges ?? 0;
          const total = res?.data?.totalAmount ?? amountNumber + charge;
          setFee(Number(charge));
          setTxnAmount(Number(total));
        }

      } catch (err) {
        console.error("FEE ERROR:", err);
        setFee(0);
        setTxnAmount(amountNumber);
      } finally {
        setLoadingFee(false);
      }
    };

    fetchFee();
  }, [settleAmount, activeTab]);

  // useEffect(() => {
  //   const amountNumber = Number(settleAmount);

  //   if (
  //     !settleAmount ||
  //     amountNumber < MIN_SETTLE_AMOUNT ||
  //     amountNumber > MAX_SETTLE_AMOUNT
  //   ) {
  //     setFee(0);
  //     setTxnAmount(0);
  //     setLoadingFee(false);
  //     return;
  //   }

  //   const calculateCharges = async () => {
  //     setLoadingFee(true);

  //     try {
  //       const payload = {
  //         paymentMode: "IMPS",
  //         provider: "SETTLEMENT",
  //         sub_provider: "EZYPAY",
  //         amount: amountNumber,
  //         commercial_type: "TRANSACTION_FEE",
  //         mid: username,
  //       };

  //       const res = await calculateFee(payload);

  //       const calculatedFee = Number(res?.fee || 0);
  //       const calculatedTxnAmount =
  //         Number(res?.txn_amount) || amountNumber + calculatedFee;

  //       setFee(calculatedFee);
  //       setTxnAmount(calculatedTxnAmount);
  //     } catch {
  //       setFee(0);
  //       setTxnAmount(amountNumber);
  //     } finally {
  //       setLoadingFee(false);
  //     }
  //   };

  //   calculateCharges();
  // }, [settleAmount]);

  //   useEffect(() => {
  //   const fetchFee = async () => {
  //     if (!settleAmount || Number(settleAmount) <= 0) return;

  //     try {
  //       setLoadingFee(true);

  //       const res = await calculateFee({
  //         paymentMode: "UPI",
  //         provider: "SETTLEMENT",
  //         sub_provider: "NIFI",
  //         amount: Number(settleAmount),
  //         commercial_type: "TRANSACTION_FEE",
  //         mid: mid,
  //       });

  //       console.log("FEE API RES →", res);

  //       // 🔴 IMPORTANT: adjust based on your API response
  //       const charge =
  //         res?.data?.fee ||
  //         res?.fee ||
  //         res?.charges ||
  //         0;

  //       const total =
  //         res?.data?.totalAmount ||
  //         Number(settleAmount) + charge;

  //       setFee(Number(charge));
  //       setTxnAmount(Number(total));

  //     } catch (err) {
  //       console.error("FEE ERROR:", err);
  //       setFee(0);
  //       setTxnAmount(Number(settleAmount));
  //     } finally {
  //       setLoadingFee(false);
  //     }
  //   };

  //   fetchFee();
  // }, [settleAmount]);


  const handleMpinChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newMpin = mpin.split("");
    newMpin[index] = value;
    const updated = newMpin.join("");
    setMpin(updated);

    if (value && index < 5) {
      mpinRefs.current[index + 1].focus();
    }
  };

  const handleMpinBackspace = (index, e) => {
    if (e.key === "Backspace" && !mpin[index] && index > 0) {
      mpinRefs.current[index - 1].focus();
    }
  };

  const handleSettleToBank = async () => {
    if (!selectedBank) {
      setSettlePopupMsg("Please select a bank.");
      setSettleStatus("failed");
      setShowSettlePopup(true);
      return;
    }

    const amountNumber = Number(settleAmount);

    if (
      !amountNumber ||
      amountNumber < MIN_SETTLE_AMOUNT ||
      amountNumber > MAX_SETTLE_AMOUNT
    ) {
      setSettlePopupMsg(
        `Amount must be between ₹${MIN_SETTLE_AMOUNT} and ₹${MAX_SETTLE_AMOUNT}.`
      );
      setSettleStatus("failed");
      setShowSettlePopup(true);
      return;
    }

    if (!mpin || mpin.length !== 6) {
      setSettlePopupMsg("Enter 6-digit MPIN.");
      setSettleStatus("failed");
      setShowSettlePopup(true);
      return;
    }

    setSettleLoading(true);
    setSettleMessage("");

    try {
      const payload = {
        mid: username,
        mpin: mpin,
        beneficiaryId: selectedBank.beneficiaryId,
        netAmount: Number(settleAmount),
        txnAmount: Number(txnAmount),
        lat: latitude,
        lng: longitude,
      };

      const res = await settleToBank(payload, `?mid=${username}`);

      if (res?.status === "SUCCESS") {
        const successMsg = `Settlement successful. Txn ID: ${res?.txnId || ""
          }`;

        setSettlePopupMsg(successMsg);
        setSettleStatus("success");
        setShowSettlePopup(true);

        // Refresh wallet & bank list
        dispatch(fetchAepsBalance());
        await handleFetchBanks();

        return;
      } else if (res?.status === "PENDING") {

        const successMsg = `Settlement Pending. Txn ID: ${res?.txnId || ""
          }`;

        setSettlePopupMsg(successMsg);
        setSettleStatus("pending");
        setShowSettlePopup(true);

        // Refresh wallet & bank list
        dispatch(fetchAepsBalance());
        await handleFetchBanks();

        return;

      } else {
        setSettlePopupMsg(
          String(res?.message || res?.status || "Settlement failed.")
        );

        setSettleStatus("failed");
        setShowSettlePopup(true);

        dispatch(fetchAepsBalance());
      }
    } catch (err) {
      setSettlePopupMsg(
        String(
          err?.response?.data?.message ||
          err?.message ||
          "Transaction failed."
        )
      );

      setSettleStatus("failed");
      setShowSettlePopup(true);
    } finally {
      setSettleLoading(false);
    }
  };

  const fetchLedger = async (targetPage = 0, loadMore = false) => {
    setLoading(true);
    try {
      const query = `?bid=${username}&page=${targetPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&feature=AEPS`;
      const res = await ledgerreport(null, query);
      const data = (res?.content || []).filter(Boolean);

      setTotalPages(res?.totalPages || 0);
      setHistory((prev) =>
        loadMore ? [...prev, ...data] : data
      );
      setPage(targetPage);
    } catch (err) {
      console.error(err);
      if (!loadMore) setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "COMMISSION" && username) {
      fetchLedger(0, false);
    }

    if (activeTab === "BANK" && username) {
      handleFetchBanks();
    }
  }, [activeTab]);

  const handleLoadMore = () => {
    if (page + 1 < totalPages) {
      fetchLedger(page + 1, true);
    }
  };

  /* ================= TOTALS ================= */

  const totalCR = history.reduce(
    (sum, tx) =>
      tx?.txnType === "CREDIT" || tx?.txnType === "Approved"
        ? sum + Number(tx?.netAmount || 0)
        : sum,
    0
  );

  const totalDR = history.reduce(
    (sum, tx) =>
      tx?.txnType === "DEBIT"
        ? sum + Number(tx?.netAmount || 0)
        : sum,
    0
  );

  const totalNetAmount = history.reduce(
    (sum, tx) => sum + Number(tx?.txnAmount || 0),
    0
  );

  const totalCharges = history.reduce(
    (sum, tx) => sum + Number(tx?.charges || 0),
    0
  );

  const totalTds = history.reduce(
    (sum, tx) => sum + Number(tx?.tds || 0),
    0
  );

  const totalCommission = history.reduce(
    (sum, tx) => sum + Number(tx?.commission || 0),
    0
  );

  /* ================= COLUMNS ================= */

  const columns = [
    { key: "txnId", label: "Txn ID" },
    {
      key: "txnDate",
      label: "Date",
      render: (v) => getDisplayDate(v),
    },
    {
      key: "narration",
      label: "Narration",
      render: (v) => (
        <span className="text-indigo-700 font-medium">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "amount_cr",
      label: "Amount (CR)",
      render: (_, row) =>
        row.txnType === "CREDIT" || row.txnType === "Approved" || row.txnType === "REFUND" ? (
          <span className="font-semibold text-green-700">
            ₹{Number(row.netAmount || 0)?.toFixed(2)}
          </span>
        ) : (
          <span className="text-gray-400">—</span>
        ),
    },
    {
      key: "amount_dr",
      label: "Amount (DR)",
      render: (_, row) =>
        row.txnType === "DEBIT" ? (
          <span className="font-semibold text-red-600">
            ₹{Number(row.netAmount || 0)?.toFixed(2)}
          </span>
        ) : (
          <span className="text-gray-400">—</span>
        ),
    },
    {
      key: "charges",
      label: "Charge",
      render: (v) => (
        <span className="font-semibold text-red-700">
          ₹{Number(v || 0)?.toFixed(2)}
        </span>
      ),
    },
    {
      key: "tds",
      label: "TDS",
      render: (v) => (
        <span className="font-semibold text-red-800">
          ₹{Number(v || 0)?.toFixed(2)}
        </span>
      ),
    },
    {
      key: "txnAmount",
      label: "Net Amount",
      render: (v, row) => {
        const value = Number(v || 0);
        if (!value) return <span className="text-gray-400">—</span>;

        if (row.txnType === "CREDIT" || row.txnType === "Approved" || row.txnType === "REFUND")
          return (
            <span className="font-semibold text-green-700">
              ₹{value?.toFixed(2)}
            </span>
          );

        if (row.txnType === "DEBIT")
          return (
            <span className="font-semibold text-red-600">
              ₹{value?.toFixed(2)}
            </span>
          );

        return <span className="text-gray-400">—</span>;
      },
    },
    {
      key: "commission",
      label: "Comm",
      render: (_, row) => {
        const value = Number(row.cashback || row.commission || 0);

        return (
          <span className="font-bold text-green-800">
            ₹{value.toFixed(2)}
          </span>
        )
      },
    },
    {
      key: "balance",
      label: "Balance",
      render: (v) => (
        <span className="font-semibold text-blue-900">
          ₹{Number(v || 0)?.toFixed(2)}
        </span>
      ),
    },
  ];

  const handleCommissionToMainTransfer = async () => {
    if (!transferCommissionAmount || transferCommissionAmount <= 0) {
      setCommissionMessage("Please enter a valid amount.");
      return;
    }

    setIsLoadingCommission(true);
    setCommissionMessage("");

    try {
      const res = await transferCommissionToMain(
        null,
        `?amount=${parseFloat(transferCommissionAmount)}&userId=${userId}`
      );

      if (res.status === "SUCCESS") {
        setCommissionMessage(
          "Commission transferred to Main Wallet successfully."
        );

        dispatch(fetchAepsBalance());

        const updated = await commissionApi();
        setCommissionBalance(updated?.balance || 0);
      } else {
        setCommissionMessage(res.message || "Commission transfer failed.");
      }
    } catch {
      setCommissionMessage("Error transferring commission.");
    } finally {
      setIsLoadingCommission(false);
      setTransferCommissionAmount("");
      setTimeout(() => setCommissionMessage(""), 2000);
    }
  };


  // const downloadExcel = () => {
  //   const rows = history.map((r) => ({
  //     TxnID: r.txnId,
  //     Date: r.txnDate,
  //     Aadhaar: r.narration,
  //     TxnAmount: r.txnAmount,
  //     NetAmount: r.netAmount,
  //     Charges: r.charges,
  //     Cashback: r.cashback,
  //     Commission: r.commission,
  //     TDS: r.tds,
  //     Balance: r.balance,
  //     Mobile: r.shopname,
  //     Status: r.txnType,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(rows);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "AEPS legder Report");
  //   XLSX.writeFile(wb, "Aeps_ledger_Report.xlsx");
  // };


  const [downloadLoader, setDownloadLoader] = useState(false);

  const downloadExcel = async () => {
    if (!username) return;

    setDownloadLoader(true);

    try {
      let allData = [];
      let currentPage = 0;
      let totalPagesLocal = 1;

      while (currentPage < totalPagesLocal) {
        const query = `?bid=${username}&page=${currentPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&feature=AEPS`;

        const res = await ledgerreport(null, query);

        const data = res?.content || [];

        allData = [...allData, ...data];
        totalPagesLocal = res?.totalPages || 1;

        currentPage++;
      }

      if (!allData.length) {
        alert("No data to download");
        return;
      }

      const rows = allData.map((r) => ({
        TxnID: r.txnId,
        Date: new Date(r.txnDate).toLocaleString("en-IN"),
        Narration: r.narration,
        TxnAmount: r.txnAmount,
        NetAmount: r.netAmount,
        Charges: r.charges,
        Cashback: r.cashback,
        Commission: r.commission,
        TDS: r.tds,
        Balance: r.balance,
        Mobile: r.shopname,
        Status: r.txnType,
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, "AEPS Ledger");

      XLSX.writeFile(
        wb,
        `AEPS_Ledger_${fromDate}_to_${toDate}.xlsx`
      );
    } catch (err) {
      console.error(err);
      alert("Download failed");
    } finally {
      setDownloadLoader(false);
    }
  };

  // const [downloadLoading,setDownloadLoading]=useState(false)

  return (
    <div className="min-h-screen sm:p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#0A2A4F]">
          Commission Section
        </h1>
        <p className="text-gray-600 text-sm mt-1">
          Manage commission reports and transfers
        </p>
      </div>

      <div className="flex flex-col sm:flex-row w-full mb-10 rounded-2xl overflow-hidden shadow-lg">
        <button
          onClick={() => setActiveTab("COMMISSION")}
          className={`flex-1 py-4 font-semibold ${activeTab === "COMMISSION"
            ? "bg-[#0A2A4F] text-white"
            : "bg-white text-[#0A2A4F]"
            }`}
        >
          Aeps Report
        </button>

        <button
          onClick={() => setActiveTab("TRANSFER")}
          className={`flex-1 py-4 font-semibold ${activeTab === "TRANSFER"
            ? "bg-green-700 text-white"
            : "bg-white text-green-700"
            }`}
        >
          Transfer Aeps to Main Wallet
        </button>

        <button
          onClick={() => setActiveTab("BANK")}
          className={`flex-1 py-4 font-semibold ${activeTab === "BANK"
            ? "bg-amber-600 text-white"
            : "bg-white text-amber-600"
            }`}
        >
          Transfer Aeps to Bank
        </button>

        {/* <button
          onClick={() => setActiveTab("UPI")}
          className={`flex-1 py-4 font-semibold relative ${activeTab === "UPI"
            ? "bg-purple-700 text-white"
            : "bg-white text-purple-700"
            }`}
        >
          Settle via UPI
        </button> */}
      </div>

      <div>
        {activeTab === "COMMISSION" && (
          <>
            {/* <div className="flex flex-col sm:flex-row gap-4 mb-6 sm:items-end">
              <div>
                <label className="block text-sm mb-1">
                  From Date
                </label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="border rounded-lg px-3 py-2 w-full"
                />
              </div>

              <div>
                <label className="block text-sm mb-1">
                  To Date
                </label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="border rounded-lg px-3 py-2 w-full"
                />
              </div>

              <button
                onClick={() => fetchLedger(0, false)}
                className="bg-[#0A2A4F] text-white px-6 py-2 rounded-lg"
              >
                Search
              </button>
            </div> */}


            <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8">
              <div className="flex flex-wrap items-center gap-4">



                {/* 📅 From Date */}
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="h-10 px-3 border rounded-lg bg-gray-50"
                />

                {/* 📅 To Date */}
                <input
                  type="date"
                  value={toDate}
                  min={fromDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="h-10 px-3 border rounded-lg bg-gray-50"
                />

                <button
                  onClick={() => fetchLedger(0, false)}
                  className="bg-[#0A2A4F] text-white px-6 py-2 rounded-lg"
                >
                  Search
                </button>

                {/* 📥 Download */}
                {/* <button
            onClick={downloadExcel}
            className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
                 shadow hover:bg-green-700 transition"
          >
            Download Excel
          </button> */}
                <button
                  onClick={downloadExcel}
                  disabled={downloadLoader}
                  className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
             shadow hover:bg-green-400 transition flex items-center gap-2 justify-center"
                >
                  {downloadLoader && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  )}
                  {downloadLoader ? "Preparing Excel..." : "Download Excel"}
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <DynamicTable
                columns={columns}
                data={history}
                isLoading={loading}
                emptyText="No ledger records found"
                rowClassName={(row) => {
                  if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
                    return "bg-red-100"; // 🔴 Darker Debit
                  }

                  if (row.txnType === "REFUND") {
                    return "bg-yellow-100"; // 🟡 Darker Refund
                  }

                  if (
                    row.txnType === "CREDIT" ||
                    row.txnType === "APPROVED"
                  ) {
                    return "bg-green-100"; // 🟢 Darker Credit
                  }

                  if (row.txnType === "REJECTED") {
                    return "bg-red-200 border-l-4 border-red-600"; // 🔴 More strong rejected
                  }

                  return "";
                }}
                footerTotals={{
                  totalCR,
                  totalDR,
                  totalNetAmount,
                  totalCharges,
                  totalTds,
                  totalCommission,
                }}
              />
            </div>

            {page + 1 < totalPages && (
              <div className="flex justify-center mt-6">
                <button
                  onClick={handleLoadMore}
                  className="px-6 py-2 bg-[#0A2A4F] text-white rounded-lg"
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}
          </>
        )}

        {activeTab === "BANK" && (
          <>
            <style>{`
      @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Mono:wght@400;500&display=swap');

      .ab-root * { box-sizing: border-box; font-family: 'DM Sans', sans-serif; }
      .ab-root input, .ab-root button { font-family: 'DM Sans', sans-serif; }
      .ab-root input::placeholder { color: #9CA3AF; font-size: 13px; }

      /* ── Bank card ── */
      .ab-bank-card {
        background: #fff;
        border: 1.5px solid #E5E7EB;
        border-radius: 14px;
        padding: 16px 18px;
        cursor: pointer;
        transition: all 0.18s ease;
        position: relative;
      }
      .ab-bank-card:hover { border-color: #93C5FD; box-shadow: 0 4px 16px rgba(37,99,235,0.08); }
      .ab-bank-card.selected { border-color: #1E3A5F; background: #F0F7FF; box-shadow: 0 4px 16px rgba(30,58,95,0.1); }
      .ab-bank-card.pending { opacity: 0.65; cursor: not-allowed; }

      /* ── Input field ── */
      .ab-field-wrap {
        height: 46px; border-radius: 11px;
        border: 1.5px solid #E5E7EB;
        background: #fff; display: flex; align-items: center;
        padding: 0 14px; gap: 10px;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .ab-field-wrap:focus-within {
        border-color: #1D4ED8;
        box-shadow: 0 0 0 3px rgba(29,78,216,0.08);
      }
      .ab-field-wrap.error { border-color: #EF4444; }
      .ab-field-wrap input {
        flex: 1; border: none; outline: none; background: transparent;
        font-size: 14px; color: #111827;
      }

      /* ── MPIN boxes ── */
      .ab-mpin-box {
        width: 44px; height: 48px; text-align: center;
        border-radius: 10px; border: 1.5px solid #E5E7EB;
        font-size: 20px; font-weight: 700; color: #1E3A5F;
        background: #fff; outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .ab-mpin-box:focus {
        border-color: #1D4ED8;
        box-shadow: 0 0 0 3px rgba(29,78,216,0.08);
      }

      /* ── Primary button ── */
      .ab-btn {
        height: 48px; border-radius: 12px; border: none;
        font-weight: 700; font-size: 14px; letter-spacing: 0.2px;
        display: flex; align-items: center; justify-content: center; gap: 8px;
        cursor: pointer; transition: background 0.2s, box-shadow 0.2s;
        width: 100%;
      }
      .ab-btn-navy  { background: #1E3A5F; color: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.1); }
      .ab-btn-navy:hover:not(:disabled)  { background: #15294A; }
      .ab-btn-amber { background: #B45309; color: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.1); }
      .ab-btn-amber:hover:not(:disabled) { background: #92400E; }
      .ab-btn-ghost {
        background: #fff; color: #374151;
        border: 1.5px solid #E5E7EB;
        box-shadow: none;
      }
      .ab-btn-ghost:hover:not(:disabled) { background: #F9FAFB; border-color: #D1D5DB; }
      .ab-btn:disabled { background: #E5E7EB; color: #9CA3AF; cursor: not-allowed; box-shadow: none; }

      /* ── Fee row ── */
      .ab-fee-row {
        display: flex; justify-content: space-between; align-items: center;
        padding: 8px 0; border-bottom: 1px solid #F3F4F6; font-size: 13.5px;
      }
      .ab-fee-row:last-child { border-bottom: none; }

      /* ── Form input (add bank) ── */
      .ab-form-input {
        display: block; width: 100%; height: 44px; border-radius: 10px;
        border: 1.5px solid #E5E7EB; padding: 0 14px;
        font-size: 14px; color: #111827; outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .ab-form-input:focus {
        border-color: #1D4ED8;
        box-shadow: 0 0 0 3px rgba(29,78,216,0.08);
      }

      @keyframes ab-spin { to { transform: rotate(360deg); } }
      @keyframes ab-fade-up {
        from { opacity: 0; transform: translateY(8px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      @keyframes ab-slide-down {
        from { opacity: 0; transform: translateY(-8px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      .ab-fade-up   { animation: ab-fade-up   0.25s ease forwards; }
      .ab-slide-down{ animation: ab-slide-down 0.25s ease forwards; }

      .ab-spinner {
        width: 16px; height: 16px;
        border: 2px solid #D1D5DB; border-top-color: transparent;
        border-radius: 50%; display: inline-block;
        animation: ab-spin 0.7s linear infinite;
      }
    `}</style>

            <div className="ab-root" style={{ maxWidth: 560 }}>

              {/* ── Section header ── */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
                <div>
                  <p style={{ fontSize: 11, fontWeight: 700, color: "#9CA3AF", letterSpacing: 1, textTransform: "uppercase", marginBottom: 4 }}>
                    Settlement
                  </p>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: "#0F172A" }}>Transfer AEPS to Bank</h2>
                </div>
                <button
                  className="ab-btn ab-btn-amber"
                  onClick={() => setShowAddBankForm((p) => !p)}
                  style={{ width: "auto", padding: "0 18px", height: 40, fontSize: 13 }}
                >
                  {showAddBankForm ? (
                    <>
                      <svg style={{ width: 14, height: 14 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                      Cancel
                    </>
                  ) : (
                    <>
                      <svg style={{ width: 14, height: 14 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                      Add Bank
                    </>
                  )}
                </button>
              </div>

              {/* ══════════════════════════════════════
          ADD BANK FORM (collapsible)
      ══════════════════════════════════════ */}
              {showAddBankForm && (
                <div className="ab-slide-down" style={{
                  background: "#fff", borderRadius: 16,
                  border: "1px solid #E5E7EB",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04)",
                  padding: 20, marginBottom: 20,
                }}>
                  <p style={{ fontSize: 11, fontWeight: 700, color: "#9CA3AF", letterSpacing: 1, textTransform: "uppercase", marginBottom: 16 }}>
                    Bank Details
                  </p>

                  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    {[
                      { name: "bankName", placeholder: "Bank Name", type: "text" },
                      { name: "bankNickName", placeholder: "Nickname (e.g. SBI Primary)", type: "text" },
                      { name: "accountNumber", placeholder: "Account Number", type: "text" },
                      { name: "ifscCode", placeholder: "IFSC Code", type: "text" },
                      { name: "accountHolderName", placeholder: "Account Holder Name as Mentioned on Cheque or Passbook", type: "text" },
                    ].map(({ name, placeholder, type }) => (
                      <div key={name}>
                        <input
                          name={name}
                          type={type}
                          placeholder={placeholder}
                          // onChange={handleBankInputChange}
                          onChange={(e) => {
                            // If it's the account holder name, strip out numbers and special characters
                            if (name === "accountHolderName") {
                              e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            }
                            handleBankInputChange(e);
                          }}
                          className="ab-form-input"
                        />
                      </div>
                    ))}

                    {/* File upload */}
                    <div>
                      <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#6B7280", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 8 }}>
                        Passbook / Cancelled Cheque <span style={{ color: "#EF4444" }}>*</span>
                      </label>
                      <label style={{
                        display: "flex", alignItems: "center", gap: 10,
                        border: "1.5px dashed #D1D5DB", borderRadius: 10,
                        padding: "12px 14px", cursor: "pointer", background: "#F9FAFB",
                        transition: "border-color 0.2s",
                      }}>
                        <svg style={{ width: 18, height: 18, color: "#9CA3AF", flexShrink: 0 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" />
                          <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                        </svg>
                        <span style={{ fontSize: 13, color: bankForm.cancelledCheque ? "#111827" : "#9CA3AF" }}>
                          {bankForm.cancelledCheque ? bankForm.cancelledCheque.name : "Click to upload image"}
                        </span>
                        <input type="file" name="cancelledCheque" accept="image/*" onChange={handleBankInputChange} style={{ display: "none" }} />
                      </label>
                      <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 5 }}>JPEG or PNG, max 5MB</p>
                    </div>
                  </div>

                  {addBankMessage && (
                    <div style={{
                      marginTop: 14, padding: "10px 14px", borderRadius: 10,
                      background: String(addBankMessage).includes("success") ? "#ECFDF5" : "#FEF2F2",
                      border: `1px solid ${String(addBankMessage).includes("success") ? "#A7F3D0" : "#FECACA"}`,
                      fontSize: 13,
                      color: String(addBankMessage).includes("success") ? "#065F46" : "#991B1B",
                    }}>
                      {addBankMessage}
                    </div>
                  )}

                  <div style={{ marginTop: 16 }}>
                    <button
                      className="ab-btn ab-btn-navy"
                      onClick={handleAddBank}
                      disabled={!isBankFormValid || addBankLoading}
                    >
                      {addBankLoading ? <><span className="ab-spinner" /> Adding Bank…</> : "Save Bank Account"}
                    </button>
                  </div>
                </div>
              )}

              {/* ══════════════════════════════════════
          BANK LIST
      ══════════════════════════════════════ */}
              {bankLoading ? (
                <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "24px 0", color: "#6B7280", fontSize: 14 }}>
                  <span className="ab-spinner" style={{ borderColor: "#D1D5DB", borderTopColor: "#1E3A5F" }} />
                  Loading bank accounts…
                </div>
              ) : bankList.length === 0 ? (
                <div style={{
                  textAlign: "center", padding: "40px 20px",
                  background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
                }}>
                  <svg style={{ width: 40, height: 40, color: "#D1D5DB", margin: "0 auto 12px" }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="8" width="18" height="13" rx="2" /><path d="M3 10h18M7 3h10" /><line x1="9" y1="14" x2="9.01" y2="14" strokeWidth="2.5" /><line x1="15" y1="14" x2="15.01" y2="14" strokeWidth="2.5" />
                  </svg>
                  <p style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 4 }}>No bank accounts yet</p>
                  <p style={{ fontSize: 13, color: "#9CA3AF" }}>Click "Add Bank" to link your account</p>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {bankList.map((bank) => {
                    // const isSelected = selectedBank?.id === bank.id;
                    const isSelected = selectedBank?.beneficiaryId === bank.beneficiaryId;
                    const isApproved = bank.status === "SUCCESS";
                    const isPending = bank.status === "PENDING";

                    return (
                      <div
                        // key={bank.id}
                        key={bank.beneficiaryId}
                        className={`ab-bank-card ab-fade-up ${isSelected ? "selected" : ""} ${!isApproved ? "pending" : ""}`}
                        // onClick={() => isApproved && setSelectedBank(isSelected ? null : bank)}
                        onClick={() => {
                          if (!isApproved) return;

                          setSelectedBank((prev) =>
                            prev?.beneficiaryId === bank.beneficiaryId
                              ? null
                              : bank
                          );
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                          {/* Bank icon */}
                          <div style={{
                            width: 42, height: 42, borderRadius: 10, flexShrink: 0,
                            background: isSelected ? "#1E3A5F" : "#F1F5F9",
                            color: isSelected ? "#fff" : "#64748B",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            transition: "all 0.2s",
                          }}>
                            <svg style={{ width: 20, height: 20 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="8" width="18" height="13" rx="2" /><path d="M3 10h18" /><polyline points="8 10 8 6 12 3 16 6 16 10" />
                            </svg>
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
                              <p style={{ fontSize: 14, fontWeight: 700, color: "#0F172A" }}>{bank.bankName}</p>
                              {/* Status badge */}
                              <span style={{
                                fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
                                padding: "2px 8px", borderRadius: 6,
                                background: isApproved ? "#ECFDF5" : isPending ? "#FFFBEB" : "#FEF2F2",
                                color: isApproved ? "#065F46" : isPending ? "#92400E" : "#991B1B",
                                border: `1px solid ${isApproved ? "#A7F3D0" : isPending ? "#FDE68A" : "#FECACA"}`,
                              }}>
                                {bank.status}
                              </span>
                            </div>
                            <p style={{ fontSize: 12, color: "#6B7280", fontFamily: "'DM Mono', monospace" }}>
                              ···· ···· {bank.accountNumber?.slice(-4) || "****"}
                            </p>
                            <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>IFSC: {bank.ifscCode}</p>
                            <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>Account Holder Name: {bank.accountHolderName}</p>
                          </div>

                          {/* Selection indicator */}
                          {isApproved && (
                            <div style={{
                              width: 22, height: 22, borderRadius: "50%", flexShrink: 0,
                              border: `2px solid ${isSelected ? "#1E3A5F" : "#D1D5DB"}`,
                              background: isSelected ? "#1E3A5F" : "transparent",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              transition: "all 0.2s",
                            }}>
                              {isSelected && (
                                <svg style={{ width: 11, height: 11, color: "#fff" }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Approved but not selected hint */}
                        {isApproved && !isSelected && (
                          <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 10, paddingTop: 10, borderTop: "1px solid #F3F4F6" }}>
                            Tap to select for settlement
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* ══════════════════════════════════════
          SETTLEMENT PANEL (slides in when bank selected)
      ══════════════════════════════════════ */}
              {selectedBank && selectedBank.status === "SUCCESS" && (
                <div className="ab-fade-up" style={{
                  marginTop: 16,
                  background: "#fff", borderRadius: 16,
                  border: "1.5px solid #1E3A5F",
                  boxShadow: "0 4px 20px rgba(30,58,95,0.1)",
                  padding: 20,
                }}>
                  {/* Panel header */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 700, color: "#9CA3AF", letterSpacing: 1, textTransform: "uppercase", marginBottom: 3 }}>
                        Settling to
                      </p>
                      <p style={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>{selectedBank.bankName}</p>
                      <p style={{ fontSize: 12, color: "#6B7280", fontFamily: "'DM Mono', monospace" }}>
                        ···· {selectedBank.accountNumber?.slice(-4)}
                      </p>
                    </div>
                    <button
                      onClick={handleCloseSettlement}
                      style={{
                        width: 34, height: 34, borderRadius: 8, border: "1.5px solid #E5E7EB",
                        background: "#fff", cursor: "pointer", display: "flex",
                        alignItems: "center", justifyContent: "center", color: "#6B7280",
                        transition: "all 0.15s",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#EF4444"; e.currentTarget.style.color = "#EF4444"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#E5E7EB"; e.currentTarget.style.color = "#6B7280"; }}
                    >
                      <svg style={{ width: 14, height: 14 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  </div>

                  {/* Amount input */}
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#6B7280", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 8 }}>
                      Amount
                    </label>
                    <div className="ab-field-wrap">
                      <span style={{ fontSize: 15, fontWeight: 700, color: "#9CA3AF", flexShrink: 0 }}>₹</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        value={settleAmount}
                        min={MIN_SETTLE_AMOUNT}
                        max={MAX_SETTLE_AMOUNT}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "") { setSettleAmount(""); return; }
                          if (Number(value) > MAX_SETTLE_AMOUNT) return;
                          if (Number(value) >= 0) setSettleAmount(value);
                        }}
                        style={{ fontFamily: "'DM Mono', monospace", fontSize: 15, fontWeight: 600 }}
                      />
                    </div>
                    <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 5 }}>
                      Min ₹{MIN_SETTLE_AMOUNT} · Max ₹{MAX_SETTLE_AMOUNT.toLocaleString()}
                    </p>
                  </div>

                  {/* Fee breakdown card */}
                  {(settleAmount && Number(settleAmount) >= MIN_SETTLE_AMOUNT) && (
                    <div className="ab-fade-up" style={{
                      background: "#F8FAFC", borderRadius: 12,
                      border: "1px solid #E5E7EB", padding: "14px 16px",
                      marginBottom: 16,
                    }}>
                      {loadingFee ? (
                        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#6B7280" }}>
                          <span className="ab-spinner" style={{ borderColor: "#D1D5DB", borderTopColor: "#1E3A5F" }} />
                          Calculating charges…
                        </div>
                      ) : (
                        <>
                          <div className="ab-fee-row">
                            <span style={{ color: "#6B7280" }}>Settlement Amount</span>
                            <span style={{ fontWeight: 600, color: "#111827", fontFamily: "'DM Mono', monospace" }}>₹{Number(settleAmount)?.toFixed(2)}</span>
                          </div>
                          <div className="ab-fee-row">
                            <span style={{ color: "#6B7280" }}>Transaction Charges</span>
                            <span style={{ fontWeight: 600, color: "#DC2626", fontFamily: "'DM Mono', monospace" }}>₹{fee?.toFixed(2)}</span>
                          </div>
                          <div className="ab-fee-row" style={{ borderTop: "1.5px solid #E5E7EB", paddingTop: 10, marginTop: 4 }}>
                            <span style={{ fontWeight: 700, color: "#0F172A", fontSize: 14 }}>Total Debit</span>
                            <span style={{ fontWeight: 700, color: "#1E3A5F", fontSize: 15, fontFamily: "'DM Mono', monospace" }}>₹{txnAmount?.toFixed(2)}</span>
                          </div>
                        </>
                      )}
                    </div>
                  )}

                  {/* MPIN */}
                  <div style={{ marginBottom: 20 }}>
                    <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#6B7280", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 10 }}>
                      6-Digit MPIN
                    </label>
                    <div style={{ display: "flex", gap: 8 }}>
                      {[...Array(6)].map((_, i) => (
                        <input
                          key={i}
                          ref={(el) => (mpinRefs.current[i] = el)}
                          type="password"
                          maxLength={1}
                          value={mpin[i] || ""}
                          onChange={(e) => handleMpinChange(i, e.target.value)}
                          onKeyDown={(e) => handleMpinBackspace(i, e)}
                          className="ab-mpin-box"
                        />
                      ))}
                    </div>
                    <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 6 }}>Your MPIN is encrypted and never stored</p>
                  </div>

                  {/* Settle button */}
                  <button
                    className="ab-btn ab-btn-navy"
                    onClick={handleSettleToBank}
                    disabled={settleLoading || loadingFee || !settleAmount || mpin.length < 6}
                  >
                    {settleLoading ? (
                      <><span className="ab-spinner" /> Processing…</>
                    ) : (
                      <>
                        <svg style={{ width: 15, height: 15 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                        Settle ₹{txnAmount > 0 ? txnAmount?.toFixed(2) : (Number(settleAmount) || 0)?.toFixed(2)} Securely
                      </>
                    )}
                  </button>

                  {/* Result message */}
                  {settleMessage && (
                    <div className="ab-fade-up" style={{
                      marginTop: 14, padding: "10px 14px", borderRadius: 10,
                      background: String(settleMessage).includes("successful") ? "#ECFDF5" : "#FEF2F2",
                      border: `1px solid ${String(settleMessage).includes("successful") ? "#A7F3D0" : "#FECACA"}`,
                      display: "flex", alignItems: "flex-start", gap: 8,
                    }}>
                      <svg style={{ width: 15, height: 15, color: String(settleMessage).includes("successful") ? "#059669" : "#DC2626", flexShrink: 0, marginTop: 1 }}
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        {String(settleMessage).includes("successful")
                          ? <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></>
                          : <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></>
                        }
                      </svg>
                      <p style={{ fontSize: 13, color: String(settleMessage).includes("successful") ? "#065F46" : "#991B1B" }}>
                        {settleMessage}
                      </p>
                    </div>
                  )}
                </div>
              )}

            </div>
          </>
        )}

        {activeTab === "UPI" && (
          <>
            <style>{`
      @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap');
      .upi-root * { box-sizing: border-box; font-family: 'DM Sans', sans-serif; }

      .upi-eyebrow { font-size: 10px; font-weight: 700; letter-spacing: 2px;
        text-transform: uppercase; color: #6D28D9; margin-bottom: 4px; }

      .upi-add-btn {
        display: flex; align-items: center; gap: 8px;
        background: #6D28D9; color: #fff; border: none; border-radius: 12px;
        padding: 10px 18px; font-family: 'DM Sans', sans-serif;
        font-size: 13px; font-weight: 700; cursor: pointer;
        transition: background 0.18s, transform 0.15s;
      }
      .upi-add-btn:hover { background: #5B21B6; transform: translateY(-1px); }

      .upi-bene-card.selected {
  border: 2px solid #6D28D9;
  background: #F5F3FF;
}

      .upi-panel {
        background: #fff; border-radius: 20px; border: 1.5px solid #6D28D9;
        padding: 24px; margin-bottom: 16px;
        animation: upiSlideDown 0.2s ease;
      }
      @keyframes upiSlideDown {
        from { opacity: 0; transform: translateY(-8px); }
        to   { opacity: 1; transform: translateY(0); }
      }

      .upi-field-label {
        font-size: 10px; font-weight: 700; letter-spacing: 1.5px;
        text-transform: uppercase; color: #9CA3AF; margin-bottom: 8px;
      }

      .upi-chip {
        padding: 6px 12px; border-radius: 8px;
        border: 1.5px solid #E8EBF4; font-family: 'DM Sans', sans-serif;
        font-size: 12px; font-weight: 700; cursor: pointer;
        background: #fff; color: #6B7280; transition: all 0.15s;
      }
      .upi-chip:hover { border-color: #C4B8FA; color: #6D28D9; }
      .upi-chip.upi-chip-active {
        background: #EDE9FE; border-color: #6D28D9; color: #6D28D9;
      }

      .upi-input-wrap {
        display: flex; align-items: center;
        border: 1.5px solid #E8EBF4; border-radius: 12px;
        background: #fff; padding: 0 14px; height: 46px;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .upi-input-wrap:focus-within {
        border-color: #6D28D9;
        box-shadow: 0 0 0 3px rgba(109,40,217,0.08);
      }
      .upi-input-wrap input {
        flex: 1; border: none; outline: none;
        font-family: 'DM Mono', monospace; font-size: 13px;
        color: #0D1117; background: transparent;
      }
      .upi-input-wrap input::placeholder {
        font-family: 'DM Sans', sans-serif; font-size: 13px; color: #C4C7D2;
      }

      .upi-suffix-chip {
        padding: 4px 10px; border-radius: 20px; border: 1px solid #E8EBF4;
        font-size: 11px; font-family: 'DM Mono', monospace; cursor: pointer;
        color: #6B7280; background: #F9FAFB; transition: all 0.15s;
      }
      .upi-suffix-chip:hover {
        border-color: #6D28D9; color: #6D28D9; background: #EDE9FE;
      }

      .upi-bene-input {
        width: 100%; height: 46px; border: 1.5px solid #E8EBF4;
        border-radius: 12px; padding: 0 14px; font-family: 'DM Sans', sans-serif;
        font-size: 13px; color: #0D1117; outline: none; background: #fff;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .upi-bene-input:focus {
        border-color: #6D28D9; box-shadow: 0 0 0 3px rgba(109,40,217,0.08);
      }
      .upi-bene-input:disabled { background: #F9FAFB; color: #9CA3AF; }

      .upi-btn-verify {
        flex: 1; height: 44px; border-radius: 12px; border: none;
        background: #6D28D9; color: #fff; font-family: 'DM Sans', sans-serif;
        font-size: 13px; font-weight: 700; cursor: pointer;
        transition: background 0.18s, transform 0.15s;
        display: flex; align-items: center; justify-content: center; gap: 8px;
      }
      .upi-btn-verify:hover { background: #5B21B6; transform: translateY(-1px); }

      .upi-btn-direct {
        flex: 1; height: 44px; border-radius: 12px;
        border: 1.5px solid #E8EBF4; background: #fff;
        color: #6B7280; font-family: 'DM Sans', sans-serif;
        font-size: 13px; font-weight: 700; cursor: pointer; transition: all 0.18s;
      }
      .upi-btn-direct:hover {
        border-color: #F87171; color: #EF4444; background: #FFF5F5;
      }

      .upi-charge-badge {
        font-size: 10px; font-weight: 700; padding: 2px 7px;
        border-radius: 4px; background: rgba(255,255,255,0.2); color: rgba(255,255,255,0.9);
      }
      .upi-charge-ghost {
        font-size: 10px; font-weight: 700; padding: 2px 7px;
        border-radius: 4px; background: #F3F4F6; color: #9CA3AF;
      }

      .upi-bene-card {
        background: #fff; border-radius: 16px; border: 1.5px solid #E8EBF4;
        padding: 16px 18px; display: flex; align-items: center; gap: 14px;
        cursor: pointer; transition: border-color 0.18s, box-shadow 0.18s;
      }
      .upi-bene-card:hover {
        border-color: #C4B8FA; box-shadow: 0 4px 18px rgba(109,40,217,0.07);
      }
      .upi-bene-avatar {
        width: 44px; height: 44px; border-radius: 12px;
        background: #EDE9FE; color: #6D28D9;
        display: flex; align-items: center; justify-content: center;
        font-size: 13px; font-weight: 800; flex-shrink: 0;
      }
      .upi-bene-name { font-size: 14px; font-weight: 700; color: #0D1117; margin-bottom: 3px; }
      .upi-bene-id { font-size: 12px; color: #6B7280; font-family: 'DM Mono', monospace; }
      .upi-bene-bank { font-size: 11px; color: #9CA3AF; margin-top: 2px; }

      .upi-badge-verified {
        display: inline-flex; align-items: center; gap: 4px;
        padding: 3px 8px; border-radius: 6px; font-size: 10px; font-weight: 700;
        background: #ECFDF5; color: #047857;
      }
      .upi-badge-unverified {
        display: inline-flex; align-items: center; gap: 4px;
        padding: 3px 8px; border-radius: 6px; font-size: 10px; font-weight: 700;
        background: #FFFBEB; color: #92400E;
      }

      .upi-empty-state {
        background: #fff; border-radius: 20px; border: 1px solid #E8EBF4;
        padding: 48px 24px; text-align: center;
      }
      .upi-empty-icon {
        width: 64px; height: 64px; border-radius: 18px; background: #EDE9FE;
        display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;
      }

      .upi-modal-overlay {
        position: fixed; inset: 0; background: rgba(13,17,23,0.55);
        display: flex; align-items: center; justify-content: center; z-index: 9999; padding: 16px;
      }
      .upi-modal {
        background: #fff; border-radius: 20px; padding: 24px;
        max-width: 400px; width: 100%; box-shadow: 0 20px 50px rgba(0,0,0,0.2);
      }
      .upi-modal-icon {
        width: 48px; height: 48px; border-radius: 14px;
        display: flex; align-items: center; justify-content: center; margin-bottom: 16px;
      }
      .upi-modal-upi-pill {
        background: #F4F6FB; border-radius: 10px; padding: 10px 14px;
        font-family: 'DM Mono', monospace; font-size: 13px; color: #0D1117;
        margin-bottom: 20px; border: 1px solid #E8EBF4;
      }
      .upi-modal-cancel {
        flex: 1; height: 40px; border-radius: 10px; border: 1.5px solid #E8EBF4;
        background: #fff; font-family: 'DM Sans', sans-serif;
        font-size: 13px; font-weight: 700; cursor: pointer; color: #6B7280;
      }
      .upi-modal-confirm {
        flex: 2; height: 40px; border-radius: 10px; border: none;
        font-family: 'DM Sans', sans-serif; font-size: 13px;
        font-weight: 700; cursor: pointer; color: #fff;
      }
      .upi-modal-confirm.verify-mode { background: #6D28D9; }
      .upi-modal-confirm.direct-mode { background: #059669; }
      .upi-modal-confirm:disabled { opacity: 0.6; cursor: not-allowed; }

      .upi-spinner {
        width: 15px; height: 15px; border: 2px solid rgba(255,255,255,0.3);
        border-top-color: #fff; border-radius: 50%;
        animation: upiSpin 0.7s linear infinite; display: inline-block;
      }
      @keyframes upiSpin { to { transform: rotate(360deg); } }

      /* REMITTER GATE */
      .remitter-gate {
        background: #F5F3FF; border: 1.5px solid #DDD6FE;
        border-radius: 16px; padding: 24px; margin-bottom: 24px;
        animation: upiSlideDown 0.2s ease;
      }
      .remitter-input {
        width: 100%; height: 46px; border: 1.5px solid #E8EBF4; border-radius: 12px;
        padding: 0 14px; font-size: 13px; outline: none;
        background: #fff; color: #0D1117; margin-bottom: 12px;
        transition: border-color 0.2s, box-shadow 0.2s;
        font-family: 'DM Sans', sans-serif;
      }
      .remitter-input:focus { border-color: #6D28D9; box-shadow: 0 0 0 3px rgba(109,40,217,0.08); }
      .remitter-input:disabled { background: #F9FAFB; color: #9CA3AF; }
      .remitter-textarea {
        width: 100%; border: 1.5px solid #E8EBF4; border-radius: 12px;
        padding: 10px 14px; font-size: 13px; outline: none; resize: none;
        background: #fff; color: #0D1117; margin-bottom: 12px;
        transition: border-color 0.2s, box-shadow 0.2s;
        font-family: 'DM Sans', sans-serif;
      }
      .remitter-textarea:focus { border-color: #6D28D9; box-shadow: 0 0 0 3px rgba(109,40,217,0.08); }
      .remitter-btn-primary {
        width: 100%; height: 44px; border-radius: 12px; border: none;
        background: #6D28D9; color: #fff; font-weight: 700; font-size: 13px;
        cursor: pointer; font-family: 'DM Sans', sans-serif;
        display: flex; align-items: center; justify-content: center; gap: 8px;
        transition: background 0.18s; margin-top: 4px;
      }
      .remitter-btn-primary:hover { background: #5B21B6; }
      .remitter-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
      .remitter-btn-success {
        width: 100%; height: 44px; border-radius: 12px; border: none;
        background: #059669; color: #fff; font-weight: 700; font-size: 13px;
        cursor: pointer; font-family: 'DM Sans', sans-serif;
        display: flex; align-items: center; justify-content: center; gap: 8px;
        transition: background 0.18s; margin-top: 4px;
      }
      .remitter-btn-success:hover { background: #047857; }
      .remitter-btn-success:disabled { opacity: 0.6; cursor: not-allowed; }
      .remitter-verified-bar {
        display: flex; align-items: center; gap: 10;
        background: #ECFDF5; border: 1.5px solid #A7F3D0;
        border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;
      }
    `}</style>

            <div className="upi-root" style={{ maxWidth: 560 }}>

              {/* ── STEP 1: REMITTER GATE ── */}
              {remitterStep !== "DONE" && (
                <div className="remitter-gate">
                  <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", color: "#6D28D9", marginBottom: 4 }}>
                    Step 1 — Verify Remitter
                  </p>
                  <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 18, lineHeight: 1.6 }}>
                    Register or verify the customer mobile before adding UPI accounts.
                  </p>

                  {/* Mobile */}
                  <label style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#9CA3AF", display: "block", marginBottom: 6 }}>
                    Mobile Number
                  </label>
                  {/* <input
                    className="remitter-input"
                    value={remitterMobile}
                    maxLength={10}
                    disabled={remitterMobileLocked}
                    onChange={(e) => /^\d*$/.test(e.target.value) && setRemitterMobile(e.target.value)}
                    placeholder="10 digit mobile"
                  /> */}

                  {/* Registration fields — shown after unregistered customer detected */}
                  {(remitterStep === "REGISTER" || remitterStep === "OTP") && (
                    <>
                      <label style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#9CA3AF", display: "block", marginBottom: 6 }}>
                        Customer Name
                      </label>
                      <input
                        className="remitter-input"
                        value={remitterName}
                        onChange={(e) => setRemitterName(e.target.value)}
                        placeholder="Full name"
                      />

                      <label style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#9CA3AF", display: "block", marginBottom: 6 }}>
                        Address
                      </label>
                      <textarea
                        className="remitter-textarea"
                        value={remitterAddress}
                        onChange={(e) => setRemitterAddress(e.target.value)}
                        placeholder="Customer address"
                        rows={2}
                      />

                      {remitterStep === "REGISTER" && (
                        <button
                          className="remitter-btn-primary"
                          onClick={handleSendRemitterOtp}
                          disabled={remitterLoading}
                        >
                          {remitterLoading && <span className="upi-spinner" />}
                          {remitterLoading ? "Sending OTP…" : "Send OTP"}
                        </button>
                      )}
                    </>
                  )}

                  {/* OTP field — shown after OTP sent */}
                  {remitterStep === "OTP" && (
                    <>
                      <label style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", color: "#9CA3AF", display: "block", marginBottom: 6, marginTop: 4 }}>
                        Enter OTP
                      </label>
                      <input
                        className="remitter-input"
                        value={remitterOtp}
                        maxLength={6}
                        onChange={(e) => /^\d*$/.test(e.target.value) && setRemitterOtp(e.target.value)}
                        placeholder="6 digit OTP"
                      />
                      <button
                        className="remitter-btn-success"
                        onClick={handleVerifyRemitterOtp}
                        disabled={remitterLoading}
                      >
                        {remitterLoading && <span className="upi-spinner" />}
                        {remitterLoading ? "Verifying…" : "Verify OTP"}
                      </button>
                    </>
                  )}

                  {/* Initial check button */}
                  {remitterStep === "CHECK" && (
                    <button
                      className="remitter-btn-primary"
                      onClick={handleCheckRemitter}
                      disabled={remitterLoading}
                    >
                      {remitterLoading && <span className="upi-spinner" />}
                      {remitterLoading ? "Checking…" : "Check Customer"}
                    </button>
                  )}

                  {/* Feedback message */}
                  {remitterMessage && (
                    <div style={{
                      marginTop: 12, padding: "10px 14px", borderRadius: 10, fontSize: 13,
                      background: remitterMessageType === "success" ? "#ECFDF5" : "#FEF2F2",
                      border: `1px solid ${remitterMessageType === "success" ? "#A7F3D0" : "#FECACA"}`,
                      color: remitterMessageType === "success" ? "#065F46" : "#991B1B",
                    }}>
                      {remitterMessage}
                    </div>
                  )}
                </div>
              )}

              {/* ── VERIFIED BADGE ── */}
              {remitterStep === "DONE" && (
                <div style={{
                  display: "flex", alignItems: "center", gap: 10,
                  background: "#ECFDF5", border: "1.5px solid #A7F3D0",
                  borderRadius: 12, padding: "12px 16px", marginBottom: 20,
                }}>
                  <svg style={{ width: 18, height: 18, color: "#059669", flexShrink: 0 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontSize: 13, fontWeight: 700, color: "#065F46" }}>
                      Remitter Verified — {remitterName || mobile_number}
                    </p>
                    <p style={{ fontSize: 11, color: "#6B7280", marginTop: 2 }}>
                      You can now manage UPI accounts below.
                    </p>
                  </div>
                  {/* <button
                    onClick={() => {
                      setRemitterStep("CHECK");
                      // setRemitterMobile("");
                      setRemitterName("");
                      setRemitterAddress("");
                      setRemitterOtp("");
                      setRemitterMessage("");
                      setRemitterMobileLocked(false);
                    }}
                    style={{
                      fontSize: 11, color: "#6B7280", background: "none",
                      border: "none", cursor: "pointer", textDecoration: "underline",
                    }}
                  >
                    Change
                  </button> */}
                </div>
              )}

              {/* ── STEP 2: UPI CONTENT — only after remitter verified ── */}
              {remitterStep === "DONE" && (
                <>
                  {/* HEADER */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
                    <div>
                      <p className="upi-eyebrow">Settlement</p>
                      <h2 style={{ fontSize: 20, fontWeight: 700, color: "#0F172A" }}>Settle via UPI</h2>
                    </div>
                    <button
                      className="upi-add-btn"
                      onClick={() => {
                        setShowUpiPopup((p) => !p);
                        setVpa(""); setBeneName(""); setManualBeneName("");
                        setUpiMsg(""); setIsVerified(false);
                        setUpiType("BANK"); setAddMode("VERIFY");
                      }}
                    >
                      {showUpiPopup ? (
                        <>
                          <svg style={{ width: 14, height: 14 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                          </svg>
                          Cancel
                        </>
                      ) : (
                        <>
                          <svg style={{ width: 14, height: 14 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                            <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                          </svg>
                          Add UPI
                        </>
                      )}
                    </button>
                  </div>

                  {/* ADD UPI PANEL */}
                  {showUpiPopup && (
                    <div className="upi-panel">
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                        <p style={{ fontSize: 15, fontWeight: 700, color: "#0F172A" }}>New UPI Beneficiary</p>
                      </div>

                      {/* PROVIDER */}
                      <p className="upi-field-label">Provider</p>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 18 }}>
                        {["BANK", "PHONEPE", "GOOGLEPAY", "PAYTM", "AMAZON"].map((type) => (
                          <button
                            key={type}
                            className={`upi-chip${upiType === type ? " upi-chip-active" : ""}`}
                            onClick={() => { setUpiType(type); setVpa(""); setIsVerified(false); }}
                          >
                            {type === "BANK" ? "Bank UPI" : type === "GOOGLEPAY" ? "Google Pay" : type.charAt(0) + type.slice(1).toLowerCase()}
                          </button>
                        ))}
                      </div>

                      {/* UPI ID */}
                      <p className="upi-field-label">UPI ID</p>
                      <div className="upi-input-wrap" style={{ marginBottom: 8 }}>
                        <input
                          value={vpa}
                          onChange={(e) => { setVpa(e.target.value); setIsVerified(false); setUpiMsg(""); }}
                          placeholder="yourname@upi"
                        />
                      </div>
                      {UPI_SUFFIX_MAP[upiType] && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 18 }}>
                          {UPI_SUFFIX_MAP[upiType].map((suffix) => (
                            <button
                              key={suffix}
                              className="upi-suffix-chip"
                              onClick={() => { const base = vpa.split("@")[0] || ""; setVpa(`${base}@${suffix}`); }}
                            >
                              @{suffix}
                            </button>
                          ))}
                        </div>
                      )}

                      {/* BENE NAME */}
                      <p className="upi-field-label" style={{ marginTop: 14 }}>
                        Beneficiary Name
                        {addMode === "VERIFY" && (
                          <span style={{ fontWeight: 400, letterSpacing: 0, textTransform: "none", fontSize: 11, color: "#9CA3AF", marginLeft: 8 }}>
                            Auto-filled after verification
                          </span>
                        )}
                      </p>
                      {addMode === "VERIFY" ? (
                        <input className="upi-bene-input" value={beneName} disabled placeholder="Auto-filled after verification" />
                      ) : (
                        <input
                          className="upi-bene-input"
                          value={manualBeneName}
                          onChange={(e) => { if (/^[a-zA-Z\s]*$/.test(e.target.value)) setManualBeneName(e.target.value); }}
                          placeholder="Enter beneficiary name"
                          autoComplete="off"
                        />
                      )}

                      <div style={{ minHeight: 20, marginTop: 8 }}>
                        {upiMsg && <p style={{ fontSize: 12, color: "#EF4444" }}>{upiMsg}</p>}
                      </div>

                      <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
                        <button
                          className="upi-btn-verify"
                          onClick={() => {
                            if (!vpa) { setUpiMsg("Enter UPI ID first"); return; }
                            setUpiMsg(""); setAddMode("VERIFY"); setConfirmType("VERIFY"); setShowVerifyConfirm(true);
                          }}
                        >
                          Verify &amp; Add <span className="upi-charge-badge">₹3</span>
                        </button>
                        {/* <button
                          className="upi-btn-direct"
                          onClick={() => {
                            if (!vpa) { setUpiMsg("Enter UPI ID first"); return; }
                            setAddMode("DIRECT");
                            if (!manualBeneName) { setUpiMsg("Enter beneficiary name"); return; }
                            setConfirmType("DIRECT"); setShowVerifyConfirm(true);
                          }}
                        >
                          Add Without Verify <span className="upi-charge-ghost">₹0</span>
                        </button> */}
                      </div>
                    </div>
                  )}

                  {/* UPI LIST */}
                  {upiLoading ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "32px 0", color: "#6B7280", fontSize: 14 }}>
                      <span className="upi-spinner" style={{ borderColor: "#DDD6FE", borderTopColor: "#6D28D9" }} />
                      Loading UPI accounts…
                    </div>
                  ) : upiList.length === 0 ? (
                    <div className="upi-empty-state">
                      <div className="upi-empty-icon">
                        <svg style={{ width: 28, height: 28, color: "#6D28D9" }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="2.5" />
                        </svg>
                      </div>
                      <p style={{ fontSize: 14, fontWeight: 700, color: "#374151", marginBottom: 6 }}>No UPI accounts yet</p>
                      <p style={{ fontSize: 13, color: "#9CA3AF", lineHeight: 1.6 }}>Click "Add UPI" to link your first UPI ID for settlement</p>
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                      {upiList.map((item) => {
                        const initials = (item.beneName || "??").split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);
                        return (
                          // <div key={item.id} className="upi-bene-card">
                          <div
                            key={item.id}
                            className={`upi-bene-card ${selectedUpi?.vpa === item.upiId ? "selected" : ""}`}
                            onClick={() => {
                              console.log("SELECTED UPI →", item);

                              setSelectedUpi({
                                vpa: item.upiId,
                                name: item.beneName,
                                bankName: item.bankName,
                                mobile: item.mobile || mobile_number,
                              });
                            }}
                          >
                            <div className="upi-bene-avatar">{initials}</div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <p className="upi-bene-name">{item.beneName}</p>
                              <p className="upi-bene-id">{item.upiId}</p>
                              <p className="upi-bene-bank">{item.bankName}</p>
                            </div>
                            <div>
                              {item.isVerified ? (
                                <span className="upi-badge-verified">
                                  <svg style={{ width: 8, height: 8 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                                    <polyline points="20 6 9 17 4 12" />
                                  </svg>
                                  Verified
                                </span>
                              ) : (
                                <span className="upi-badge-unverified">Unverified</span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {selectedUpi && (
                    <div style={{ marginTop: 16 }}>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        value={settleAmount}
                        min={MIN_SETTLE_AMOUNT}
                        max={MAX_SETTLE_AMOUNT}
                        onChange={(e) => {
                          console.log("AMOUNT →", e.target.value);
                          setSettleAmount(e.target.value);
                        }}
                        style={{
                          width: "100%",
                          padding: "10px",
                          borderRadius: "8px",
                          border: "1px solid #ccc",
                          marginBottom: "10px",
                        }}
                      />
                      <p style={{ fontSize: 11, color: "#393a3cff", marginTop: 5 }}>
                        Min ₹{MIN_SETTLE_AMOUNT} · Max ₹{MAX_SETTLE_AMOUNT.toLocaleString()}
                      </p>

                      {/* <input
                        type="password"
                        placeholder="Enter MPIN"
                        value={mpin}
                        onChange={(e) => setMpin(e.target.value)}
                        maxLength={6}
                        style={{
                          width: "100%",
                          padding: "10px",
                          borderRadius: "8px",
                          border: "1px solid #ccc",
                          marginTop: "10px",
                        }}
                      /> */}

                      {/* {(settleAmount && Number(settleAmount) >= MIN_SETTLE_AMOUNT) && (<div className="ab-fade-up" style={{ background: "#F8FAFC", borderRadius: 12, border: "1px solid #E5E7EB", padding: "14px 16px", marginBottom: 16, }}> {loadingFee ? (<div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#6B7280" }}> <span className="ab-spinner" style={{ borderColor: "#D1D5DB", borderTopColor: "#1E3A5F" }} /> Calculating charges… </div>) : (<> <div className="ab-fee-row"> <span style={{ color: "#6B7280" }}>Settlement Amount</span> <span style={{ fontWeight: 600, color: "#111827", fontFamily: "'DM Mono', monospace" }}>₹{Number(settleAmount)?.toFixed(2)}</span> </div> <div className="ab-fee-row"> <span style={{ color: "#6B7280" }}>Transaction Charges</span> <span style={{ fontWeight: 600, color: "#DC2626", fontFamily: "'DM Mono', monospace" }}>₹{fee?.toFixed(2)}</span> </div> <div className="ab-fee-row" style={{ borderTop: "1.5px solid #E5E7EB", paddingTop: 10, marginTop: 4 }}> <span style={{ fontWeight: 700, color: "#0F172A", fontSize: 14 }}>Total Debit</span> <span style={{ fontWeight: 700, color: "#1E3A5F", fontSize: 15, fontFamily: "'DM Mono', monospace" }}>₹{txnAmount?.toFixed(2)}</span> </div> </>)} </div>)} */}

                      {(settleAmount && Number(settleAmount) > 0) && (
                        <div className="ab-fade-up">
                          {loadingFee ? (
                            <div>Calculating charges…</div>
                          ) : (
                            <>
                              <div className="ab-fee-row">
                                <span>Settlement Amount</span>
                                <span>₹{Number(settleAmount).toFixed(2)}</span>
                              </div>

                              <div className="ab-fee-row">
                                <span>Transaction Charges</span>
                                <span style={{ color: "#DC2626" }}>
                                  ₹{fee.toFixed(2)}
                                </span>
                              </div>

                              <div className="ab-fee-row">
                                <span>Total Debit</span>
                                <span>₹{txnAmount.toFixed(2)}</span>
                              </div>
                            </>
                          )}
                        </div>
                      )}

                      {upiMsg && (
                        <div
                          style={{
                            marginTop: 10,
                            padding: "10px",
                            borderRadius: "8px",
                            background:
                              upiMsg.toLowerCase().includes("success")
                                ? "#DCFCE7"
                                : "#FEE2E2",
                            color:
                              upiMsg.toLowerCase().includes("success")
                                ? "#166534"
                                : "#991B1B",
                            fontSize: "13px",
                            textAlign: "center",
                            fontWeight: 500,
                          }}
                        >
                          {upiMsg}
                        </div>
                      )}

                      <button
                        onClick={() => setShowMpinPopup(true)}
                        disabled={!Number(settleAmount) || settleLoading}
                        style={{
                          width: "100%",
                          padding: "12px",
                          background: "#6D28D9",
                          color: "#fff",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                          opacity: !Number(settleAmount) ? 0.5 : 1,
                        }}
                      >
                        {settleLoading ? "Processing..." : "Proceed"}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* CONFIRM MODAL — outside DONE guard so overlay always renders on top */}
            {showVerifyConfirm && (
              <div className="upi-modal-overlay">
                <div className="upi-modal">
                  <div className="upi-modal-icon" style={{ background: confirmType === "VERIFY" ? "#EDE9FE" : "#ECFDF5" }}>
                    {confirmType === "VERIFY" ? (
                      <svg style={{ width: 22, height: 22 }} viewBox="0 0 24 24" fill="none" stroke="#6D28D9" strokeWidth="2" strokeLinecap="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
                      </svg>
                    ) : (
                      <svg style={{ width: 22, height: 22 }} viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round">
                        <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                      </svg>
                    )}
                  </div>

                  <h3 style={{ fontSize: 16, fontWeight: 700, color: "#0D1117", marginBottom: 8 }}>
                    {confirmType === "VERIFY" ? "Verify UPI ID" : "Add Without Verification"}
                  </h3>
                  <p style={{ fontSize: 13, color: "#6B7280", lineHeight: 1.6, marginBottom: 16 }}>
                    {confirmType === "VERIFY"
                      ? <>₹3 will be deducted from your AEPS wallet for verification.<br /><span style={{ fontSize: 11, color: "#9CA3AF" }}>UPI सत्यापन के लिए ₹3 काटे जाएंगे।</span></>
                      : <>No charge. UPI added without verification — transactions may carry higher risk.<br /><span style={{ fontSize: 11, color: "#9CA3AF" }}>कोई शुल्क नहीं काटा जाएगा।</span></>
                    }
                  </p>

                  <div className="upi-modal-upi-pill">{vpa}</div>

                  <div style={{ minHeight: 20, marginBottom: 12 }}>
                    {upiMsg && (
                      <p style={{ fontSize: 13, color: "#DC2626", textAlign: "center" }}>
                        {upiMsg}
                      </p>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: 8 }}>
                    <button className="upi-modal-cancel" onClick={() => setShowVerifyConfirm(false)}>Cancel</button>
                    <button
                      disabled={verifying}
                      className={`upi-modal-confirm ${confirmType === "VERIFY" ? "verify-mode" : "direct-mode"}`}
                      onClick={() => confirmType === "VERIFY" ? verifyAndAddUpi() : addUpiDirectly()}
                    >
                      {verifying ? (
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                          <span className="upi-spinner" /> Processing…
                        </span>
                      ) : confirmType === "VERIFY" ? "Confirm & Verify" : "Confirm & Add"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}


        {activeTab === "TRANSFER" && (
          <div className="w-full sm:max-w-md">
            <h2 className="text-xl font-bold text-green-600 mb-4">
              Transfer Aeps Balance to Main Wallet
            </h2>

            <div className="mb-4 text-green-700 font-semibold">
              Available Aeps Balance: ₹
              {commissionBalance.toLocaleString()}
            </div>

            <input
              type="number"
              value={transferCommissionAmount}
              onChange={(e) =>
                setTransferCommissionAmount(e.target.value)
              }
              placeholder="Enter Commission Amount"
              className="w-full border rounded-lg px-3 py-2 mb-4"
            />

            <button
              onClick={handleCommissionToMainTransfer}
              disabled={isLoadingCommission}
              className="w-full bg-green-600 text-white py-2 rounded-lg font-semibold"
            >
              {isLoadingCommission ? "Processing..." : "Transfer Now"}
            </button>

            {commissionMessage && (
              <p className="mt-3 text-sm text-green-600 font-medium">
                {commissionMessage}
              </p>
            )}
          </div>
        )}
      </div>

      {showChequePopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "16px"
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 420,
              maxHeight: "90vh",
              overflowY: "auto",
              background: "#fff",
              borderRadius: 16,
              padding: "20px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
              fontFamily: "DM Sans, sans-serif"
            }}
          >
            {/* HEADER */}
            <h3
              style={{
                fontWeight: 700,
                fontSize: 18,
                marginBottom: 8
              }}
            >
              Document Verification
            </h3>

            <p
              style={{
                fontSize: 13,
                color: "#6B7280",
                marginBottom: 16
              }}
            >
              Please confirm the following before uploading.
            </p>

            {/* DOCUMENT TYPE */}
            <label style={{ fontWeight: 600, fontSize: 13 }}>
              Document Type / दस्तावेज़ प्रकार
            </label>

            <div style={{ marginTop: 8, marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, marginBottom: 6 }}>
                <input
                  type="radio"
                  name="doc"
                  value="CHEQUE"
                  onChange={(e) => setDocumentType(e.target.value)}
                />
                &nbsp; Cancelled Cheque / रद्द किया हुआ चेक
              </label>

              <label style={{ display: "block", fontSize: 13 }}>
                <input
                  type="radio"
                  name="doc"
                  value="PASSBOOK"
                  onChange={(e) => setDocumentType(e.target.value)}
                />
                &nbsp; Passbook / बैंक पासबुक
              </label>
            </div>

            {/* DOCUMENT INSTRUCTION */}
            {documentType && (
              <div
                style={{
                  background: "#F8FAFC",
                  padding: 12,
                  borderRadius: 10,
                  fontSize: 12,
                  marginBottom: 16,
                  lineHeight: 1.5
                }}
              >
                {documentType === "CHEQUE" && (
                  <>
                    <b>English:</b> Ensure the account holder name printed on the cheque
                    is clearly visible. If the cheque does not have the account holder
                    name printed on it, please upload the passbook instead.
                    <br />
                    <br />
                    <b>Hindi:</b> कृपया सुनिश्चित करें कि चेक पर खाता धारक का नाम स्पष्ट
                    दिखाई दे। यदि चेक पर खाता धारक का नाम छपा हुआ नहीं है, तो कृपया
                    पासबुक अपलोड करें।
                  </>
                )}

                {documentType === "PASSBOOK" && (
                  <>
                    <b>English:</b> Upload the passbook page showing account number
                    and account holder name.
                    <br />
                    <b>Hindi:</b> कृपया पासबुक का वह पेज अपलोड करें जिसमें खाता संख्या
                    और खाता धारक का नाम दिखाई देता हो।
                  </>
                )}
              </div>
            )}

            {/* NAME CONFIRMATION */}
            <label style={{ fontSize: 13, fontWeight: 600 }}>
              Is the account holder name same as registered with BingoPay?
              <br />
              क्या खाता धारक का नाम BingoPay में रजिस्टर्ड नाम जैसा ही है?
            </label>

            <div style={{ marginTop: 8, marginBottom: 18 }}>
              <label style={{ marginRight: 20 }}>
                <input
                  type="radio"
                  name="holderNameConfirm"
                  value="YES"
                  checked={holderNameConfirm === "YES"}
                  onChange={(e) => {
                    setHolderNameConfirm(e.target.value);
                    setNameMismatchChoice("");
                  }}
                />
                &nbsp; Yes / हाँ
              </label>

              <label>
                <input
                  type="radio"
                  name="holderNameConfirm"
                  value="NO"
                  checked={holderNameConfirm === "NO"}
                  onChange={(e) => {
                    setHolderNameConfirm(e.target.value);
                    setNameMismatchChoice("");
                  }}
                />
                &nbsp; No / नहीं
              </label>
            </div>

            {/* MISMATCH WARNING */}
            {holderNameConfirm === "NO" && (
              <div
                style={{
                  background: "#FEF2F2",
                  border: "1px solid #FECACA",
                  padding: 12,
                  borderRadius: 10,
                  marginBottom: 18,
                  fontSize: 13
                }}
              >
                <b>Name mismatch detected.</b>

                <p style={{ marginTop: 6 }}>
                  The account holder name must match the name registered with BingoPay.
                  Please choose one option below.
                </p>

                <div style={{ marginTop: 10 }}>
                  <label style={{ display: "block", marginBottom: 6 }}>
                    <input
                      type="radio"
                      name="mismatchOption"
                      value="UPDATE_NAME"
                      checked={nameMismatchChoice === "UPDATE_NAME"}
                      onChange={(e) => setNameMismatchChoice(e.target.value)}
                    />
                    &nbsp; Update my name with BingoPay
                  </label>

                  <label style={{ display: "block" }}>
                    <input
                      type="radio"
                      name="mismatchOption"
                      value="UPLOAD_MATCHING_DOC"
                      checked={nameMismatchChoice === "UPLOAD_MATCHING_DOC"}
                      onChange={(e) => setNameMismatchChoice(e.target.value)}
                    />
                    &nbsp; Upload cheque/passbook with same name
                  </label>
                </div>
              </div>
            )}

            {/* ACTION BUTTONS */}
            <div
              style={{
                display: "flex",
                gap: 10,
                flexWrap: "wrap"
              }}
            >
              <button
                onClick={() => setShowChequePopup(false)}
                style={{
                  flex: 1,
                  minWidth: 120,
                  padding: "10px",
                  borderRadius: 8,
                  border: "1px solid #D1D5DB",
                  background: "#fff",
                  fontWeight: 600
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleConfirmDocument}
                style={{
                  flex: 1,
                  minWidth: 120,
                  padding: "10px",
                  borderRadius: 8,
                  background: "#1E3A5F",
                  color: "#fff",
                  border: "none",
                  fontWeight: 600
                }}
              >
                Confirm & Upload
              </button>
            </div>
          </div>
        </div>
      )}
      {showMpinPopup && (
        <div className="upi-modal-overlay">
          <div className="upi-modal">

            <h3 style={{ marginBottom: 10 }}>Enter MPIN</h3>

            <input
              type="password"
              value={mpin}
              onChange={(e) => setMpin(e.target.value)}
              maxLength={6}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                textAlign: "center",
                fontSize: "18px",
                letterSpacing: "8px",
              }}
            />

            <div style={{ display: "flex", gap: 10, marginTop: 15 }}>

              <button
                onClick={() => {
                  setShowMpinPopup(false);
                  setMpin("");
                }}
                style={{ flex: 1 }}
              >
                Cancel
              </button>

              <button
                onClick={async () => {
                  if (!mpin || mpin.length !== 6) {
                    setUpiMsg("Enter valid MPIN");
                    return;
                  }

                  setShowMpinPopup(false);

                  await handleUpiSettleWithMpin(mpin);
                }}
                style={{ flex: 1 }}
              >
                Confirm
              </button>

            </div>

          </div>
        </div>
      )}

      {showSettlePopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white w-[90%] max-w-sm rounded-2xl p-6 shadow-2xl text-center animate-fadeIn">

            <div
              className={`mx-auto mb-4 flex items-center justify-center w-16 h-16 rounded-full ${settleStatus === "success"
                  ? "bg-green-100"
                  : settleStatus === "pending"
                    ? "bg-yellow-100"
                    : "bg-red-100"
                }`}
            >
              {settleStatus === "success" ? (
                <span className="text-3xl text-green-600">✓</span>
              ) : settleStatus === "pending" ? (
                <span className="text-3xl text-yellow-600">⏳</span>
              ) : (
                <span className="text-3xl text-red-600">✕</span>
              )}
            </div>

            <h2
              className={`text-xl font-bold mb-2 ${settleStatus === "success"
                  ? "text-green-700"
                  : settleStatus === "pending"
                    ? "text-yellow-700"
                    : "text-red-700"
                }`}
            >
              {settleStatus === "success"
                ? "Settlement Successful"
                : settleStatus === "pending"
                  ? "Settlement Pending"
                  : "Settlement Failed"}
            </h2>

            <p className="text-gray-600 text-sm mb-6">
              {settlePopupMsg}
            </p>

            <button
              onClick={() => {
                setShowSettlePopup(false);
                handleCloseSettlement();
              }}
              className={`w-full py-3 rounded-xl font-semibold text-white ${settleStatus === "success"
                  ? "bg-green-600 hover:bg-green-700"
                  : settleStatus === "pending"
                    ? "bg-yellow-500 hover:bg-yellow-600"
                    : "bg-red-600 hover:bg-red-700"
                }`}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* {showSettlePopup && (
        <div className="upi-modal-overlay">
          <div className="upi-modal" style={{ textAlign: "center" }}>

            <h3
              style={{
                color: settleStatus === "success" ? "#16A34A" : "#DC2626",
                marginBottom: 10,
              }}
            >
              {settleStatus === "success" ? "Success" : "Failed"}
            </h3>

            <p style={{ fontSize: 14, marginBottom: 15 }}>
              {settlePopupMsg}
            </p>

            <button
              onClick={() => setShowSettlePopup(false)}
              style={{
                width: "100%",
                padding: "10px",
                background: "#6D28D9",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
              }}
            >
              OK
            </button>

          </div>
        </div>
      )} */}
    </div>
  );
};

export default AepsReport;
